"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var UI = _interopRequireWildcard(require("solid-ui"));
var $rdf = _interopRequireWildcard(require("rdflib"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/*   Single video play Pane
 **
 */
var _default = exports["default"] = {
  icon: UI.icons.iconBase + 'noun_1619.svg',
  name: 'video',
  // Does the subject deserve an slideshow pane?
  label: function label(subject, context) {
    var kb = context.session.store;
    var typeURIs = kb.findTypeURIs(subject);
    var prefix = $rdf.Util.mediaTypeClass('video/*').uri.split('*')[0];
    for (var t in typeURIs) {
      if (t.startsWith(prefix)) return 'Play video';
    }
    return null;
  },
  render: function render(subject, context) {
    var kb = context.session.store;
    var dom = context.dom;
    var div = dom.createElement('div');
    var video = div.appendChild(dom.createElement('video'));
    video.setAttribute('controls', 'yes');
    // get video with authenticated fetch
    kb.fetcher._fetch(subject.uri).then(function (response) {
      return response.blob();
    }).then(function (myBlob) {
      var objectURL = URL.createObjectURL(myBlob);
      video.setAttribute('src', objectURL); // w640 h480 //
    });
    video.setAttribute('width', '100%');
    return div;
  }
}; // ends
//# sourceMappingURL=videoPane.js.map